<template>
  <list-layout class="list-layout" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">维修订单列表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" @keyup.enter.native="handleSearch" placeholder="请输入物料名称/物料编码"></el-input>
      </el-form-item>
      <el-form-item label="维修订单">
        <el-input class="form-input" v-model="Search.OrderCode" @keyup.enter.native="handleSearch"  placeholder="请输入维修订单编码"></el-input>
      </el-form-item>
      <el-form-item label="订单来源">
        <el-select class="form-input" clearable filterable v-model="Search.OrderType" placeholder="请选择或输入订单来源">
          <el-option
            v-for="item in OriginalOrderTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="维修类型">
        <el-select v-model="Search.RepairType" clearable filterable placeholder="请选择或输入维修类型">
          <el-option
            v-for="item in RepairTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="维修时间">
        <el-date-picker
          v-model="warehouseDate"
          type="daterange"
          align="right"
          placeholder="选择日期范围"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch">查询</el-button>
        <router-link :to="{name: 'NewRepair'}">
          <el-button type="primary">新建维修单</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="tab" slot="tabs">
      <el-tabs class="tab" :value="activename" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待确认" name="draft"></el-tab-pane>
        <el-tab-pane label="待收货" name="waitreceipt"></el-tab-pane>
        <el-tab-pane label="待质检" name="waitqc"></el-tab-pane>
        <el-tab-pane label="待复核" name="waitreview"></el-tab-pane>
        <el-tab-pane label="维修中" name="repairing"></el-tab-pane>
        <el-tab-pane label="已完成" name="finished"></el-tab-pane>
        <el-tab-pane label="已取消" name="cancelled"></el-tab-pane>
      </el-tabs>
    </div>
    <complex-grid v-loading="IsLoading" element-loading-text="加载中" :config="tableConfig" :data="tableData" slot="main-content">
      <template slot="sub-header" scope="props">
        <el-col :span="21">
          <span>{{props.row.OrderDate | date('YYYY-MM-DD HH:mm:ss')}}</span>
          <span style="margin-left: 20px">维修订单：{{props.row.Code}}</span>
          <span style="margin-left: 20px">订单来源：{{props.row.OriginalOrderType | OrderSource}} <span style="color:#20a0ff;" v-if="props.row.OriginalOrderType != null">({{props.row.OriginalOrderCode}})</span></span>
          <span style="margin-left: 20px">维修类型：{{props.row.RepairType | RepairType}}</span>
          <span style="margin-left: 20px">维修数量：{{props.row.Quantity}}</span>
          <span style="margin-left: 20px">区域：{{region(props)}}</span>
        </el-col>
        <el-col :span="3">
          状态：<span style="color: red">{{props.row.State | ServiceState}}</span>
        </el-col>
      </template>
      <template slot="BatchCode" scope="props">
        {{(props.row.Lot ? props.row.Lot.Code : props.row.LotCode) | NullShowCN}}
      </template>
       <template slot="ProductName" scope="props">
        <p style="margin: 4px 0">{{(props.row.Lot ? props.row.Lot.Product.Name : props.row.ProductName) | NullShowCN}}</p>
        <p style="margin: 4px 0">物料编码：{{props.row.Lot ? props.row.Lot.Product.Code : '-' }}</p>
      </template>
      <template slot="ProductConditionName" scope="props">
        <el-tag type="primary">{{(props.row.Lot && props.row.Lot.Condition?props.row.Lot.Condition.Name:props.row.Condition.Name) | NullShowCN}}</el-tag>
      </template>
      <template slot="BrandName" scope="props">
        {{(props.row.Lot && props.row.Lot.Product.Brand? props.row.Lot.Product.Brand.Name:props.row.BrandName) | NullShowCN}}
      </template>
      <template slot="ModelName" scope="props">
        {{(props.row.Lot && props.row.Lot.Product.Model? props.row.Lot.Product.Model.Name:props.row.ModelName) | NullShowCN}}
      </template>
      <template slot="ModuleName" scope="props">
        {{(props.row.Lot && props.row.Lot.Product.Module? props.row.Lot.Product.Module.Name:props.row.ModuleName) | NullShowCN}}
      </template>
      <template slot="action-bar" scope="props">
        <el-button type="text" @click.native="toDetail(props)">查看</el-button>
      </template>
    </complex-grid>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/pages/Repair/ListLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Regions: [],
      Search: {
        Product: null,
        OrderCode: null,
        OrderType: null,
        RepairType: null,
        CustomCode: null,
      },
      OriginalOrderTypes: [
        {label: '入库单', value: 'InStockPicking'},
        {label: '租赁单', value: 'RentalOrder'},
        {label: '发货单', value: 'OutStockPicking'},
        {label: '内部调拨单', value: 'InternalStockPicking'},
        {label: '物流单', value: 'DeliveryOrder'},
        {label: '备用件退货单', value: 'DeliveryBackupReturn'},
        {label: '质检单', value: 'QcOrder'},
        {label: '租赁退货单', value: 'RentalReturnOrder'},
        {label: '租赁换货单', value: 'RentalExchangeOrder'},
        {label: '租赁维修单', value: 'RentalRepairOrder'},
        {label: '盘点单', value: 'InventoryOrder'},
        {label: '维修订单', value: 'RepairOrder'},
        {label: '维修单', value: 'RepairWorkOrder'},
        {label: '委外维修单', value: 'ExternalRepairWorkOrder'},
        {label: '自建', value: ''},
      ],
      IsLoading: false,
      activename: 'all',
      warehouseDate: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      RepairTypes: [
        {label: '外部维修', value: 'external'},
        {label: '租赁维修', value: 'rental'},
        {label: '委托维修', value: 'delegated'},
        {label: '代管维修', value: 'managed'},
        {label: '拆件维修', value: 'parts'},
        {label: '自建维修', value: 'custom'},
      ],
      tableConfig: {
        dataPrefix: 'Lines',
        column: [
          {
            label: '批次号',
            width: '190px',
            slot: 'BatchCode',
          },
          {
            label: '物料名称',
            width: '260px',
            slot: 'ProductName',
          },
          {
            label: '品项',
            width: '100px',
            slot: 'ProductConditionName',
          },
          {
            label: '品牌',
            width: '100px',
            slot: 'BrandName',
          },
          {
            label: '机型',
            width: '140px',
            slot: 'ModelName',
          },
          {
            label: '模块',
            slot: 'ModuleName',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '160px',
          },
        ],
      },
      tableData: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          },
        }],
      },
    }
  },
  methods: {
    region: function(props) {
      for (var a = 0; a < this.Regions.length; a++) {
        if (props.row.RegionId === this.Regions[a].Id) {
          return this.Regions[a].Name
        }
      }
    },
    toDetail: function(props) {
      this.$router.push('/repair/' + props.row.Id)
    },
    initReion: function() {
      const Region = o('Region')
      Region.get().then(({ data, inlinecount }) => {
        this.Regions = data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    handleSearch() {
      this.IsLoading = true
      const Services = o('RepairOrder').expand('Partner($select=Id,Name),Principal($select=Id,Name),Lines($expand=Lot,Condition)')
      let filters = []
      if (this.Search.Code) {
        filters.push(`contains(Code, '${this.Search.Code}')`)
      }
      if (this.Search.RepairType) {
        filters.push(`contains(RepairType, '${this.Search.RepairType}')`)
      }
      if (this.Search.OrderType) {
        filters.push(`contains(OriginalOrderType, '${this.Search.OrderType}')`)
      }
      if (this.Search.Product) {
        filters.push(`(Lines/any(p:contains(p/Lot/Product/Name, '${this.Search.Product}')) 
          or Lines/any(p:contains(p/Lot/Product/Code, '${this.Search.Product}'))
          or Lines/any(p:contains(p/ProductName, '${this.Search.Product}'))
          or Lines/any(p:contains(p/LotCode, '${this.Search.Product}'))
        )`)
      }
      if (this.activename === 'all') {
      } else if (this.activename === 'finished') {
        filters.push(`(State eq 'finished')`)
      } else if (this.activename === 'draft') {
        filters.push(`(State eq 'draft')`)
      } else if (this.activename === 'waitreceipt') {
        filters.push(`(State eq 'receiving')`)
      } else if (this.activename === 'cancelled') {
        filters.push(`(State eq 'cancelled')`)
      } else if (this.activename === 'waitqc') {
        filters.push(`(State eq 'qc')`)
      } else if (this.activename === 'waitreview') {
        filters.push(`(State eq 'review')`)
      } else {
        filters.push(`(State eq 'repairing')`)
      }
      if (this.Search.OrderCode) {
        filters.push(`Code eq '${this.Search.OrderCode}'`)
      }
      if (this.warehouseDate) {
        const startDate = this.$moment(this.warehouseDate[0]).utc().add(1, 'd').set({hour: 0, minute: 0, second: 0}).format()
        const endDate = this.$moment(this.warehouseDate[1]).utc().add(2, 'd').set({hour: 0, minute: 0, second: 0}).add(-1, 's').format()
        filters.push(`(OrderDate ge ${startDate} and OrderDate le ${endDate})`)
      }
      if (filters.length > 0) {
        Services.filter(filters.join(' and '))
      }
      Services.inlineCount()
      Services.skip((this.currentPage - 1) * this.pageSize)
      Services.top(this.pageSize)
      Services.orderBy('OrderDate', 'desc')
      Services.get().then(({ data, inlinecount }) => {
        data.forEach(function(row) {
          row.Quantity = 0
          row.Lines.forEach(function(e) {
            row.Quantity += e.Quantity
          }, this)
        }, this)
        this.tableData = data
        this.total = inlinecount
        // loading.close()
      }).fail((error) => {
        this.$alert(error.message)
      }).finally(() => {
        this.IsLoading = false
      })
    },
    handleTabClick({name}) {
      this.activename = name
      this.handleSearch()
    },
    handleChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
  },
  components: {
    ListLayout,
    ComplexGrid,
  },
  created() {
    this.handleSearch()
    this.initReion()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
.list-layout .complex-table .sub-row-table .sub-body .text-center{
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// RepairListPage.vue?39642ffb